import React from 'react';
import PropTypes from 'prop-types';

export default class ImageSelection extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={`proc-image-selection-container ${this.props.className}`}>
        {this._renderImages(4)}
        {this._renderImages(3)}
      </div>
    );
  }

  _renderImages(columnNum) {
    let rows = [];
    for (let i = 0; i < Math.ceil(this.props.images.length / columnNum); i++) {
      rows.push('');
    }

    return rows.map((_src, index) => {
      let images = [];
      for (let i = 0; i < columnNum; i++) {
        let j = i + columnNum * index;
        if (!this.props.images[j]) {
          break;
        }
        images.push(
          <div key={j} className={`images-container`}>
            <img
              src={this.props.images[j]}
              className={`image ${this.props.value === j ? 'selected' : ''}`}
              onClick={this._onClick.bind(this, j)}
            />
            <div className={'title proc-small-font'}>{this.props.labels[j]}</div>
          </div>
        );
      }

      return (
        <div key={`row-index${index}`} className={`image-selection-row column-num${columnNum}`}>
          {images}
        </div>
      );
    });
  }

  _onClick(index) {
    this.props.onSelected(index);
  }
}

ImageSelection.propTypes = {
  value: PropTypes.number,
  images: PropTypes.array,
  labels: PropTypes.array,
  onSelected: PropTypes.func,
  className: PropTypes.string,
};

ImageSelection.defaultProps = {};
